module.exports = require("./../../_gen/starling/rendering/Painter");